import React from 'react';
import { useParams } from 'react-router-dom';
import { StudentCardBookingForm } from './StudentCardBookingForm';
import {
  useGetStudentBookInfo,
  type StudentSelectedTime,
} from '../../../graphql';
import { Alert, Loading } from '../../../../../components';

type StudentCardBookingProps = {
  studentNumber: string;
  entryYear: string;
  studentSelectedTime: StudentSelectedTime;
  refetchCollectTime: () => void;
};

export const StudentCardBooking: React.FC<StudentCardBookingProps> = ({
  studentNumber,
  entryYear,
  studentSelectedTime,
  refetchCollectTime,
}: StudentCardBookingProps) => {
  const { applicationId = '' } = useParams();

  const {
    studentBookInfo,
    loading,
    error,
    refetch: refetchBookInfo,
  } = useGetStudentBookInfo(applicationId, entryYear);

  if (error) {
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: `Error Occurs.` + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }
  return loading ? (
    <Loading />
  ) : (
    <StudentCardBookingForm
      studentNumber={studentNumber}
      entryYear={entryYear}
      studentBookInfo={studentBookInfo}
      studentSelectedTime={studentSelectedTime}
      refetch={() => {
        refetchBookInfo();
        refetchCollectTime();
      }}
    />
  );
};
